import * as React from "react";
const SVGComponent = (props) => (
  <svg
    width={70}
    height={70}
    viewBox="0 0 101 101"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <circle cx={50.9453} cy={50.8545} r={50} fill="#0A5587" fillOpacity={0.1} />
    <path
      d="M67.4351 32.5215L63.7684 36.1882M63.7684 36.1882L69.2684 41.6882L62.8517 48.1048L57.3517 42.6048M63.7684 36.1882L57.3517 42.6048M49.8167 50.1398C50.7634 51.0738 51.5159 52.1859 52.031 53.4119C52.546 54.638 52.8135 55.9538 52.818 57.2836C52.8224 58.6135 52.5638 59.9311 52.0569 61.1605C51.5501 62.39 50.805 63.5071 49.8647 64.4474C48.9243 65.3878 47.8073 66.1328 46.5778 66.6397C45.3483 67.1465 44.0307 67.4052 42.7009 67.4007C41.3711 67.3962 40.0552 67.1288 38.8292 66.6137C37.6031 66.0986 36.4911 65.3461 35.5571 64.3995C33.7203 62.4977 32.704 59.9507 32.7269 57.3069C32.7499 54.663 33.8104 52.134 35.6799 50.2645C37.5494 48.3949 40.0785 47.3345 42.7223 47.3115C45.3661 47.2885 47.9132 48.3049 49.8149 50.1417L49.8167 50.1398ZM49.8167 50.1398L57.3517 42.6048"
      stroke="#0A5587"
      strokeWidth={3.66667}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
export default SVGComponent;
